/**
 * FreeShippingBarVariant — Cart Summary V2
 *
 * Composes the free shipping progress bar on top of the default summary.
 * The progress bar appears above the subtotal/savings/checkout section.
 */

'use client';

import { useFreeShipping } from '@/lib/hooks/use-free-shipping';
import { FreeShippingProgressBar } from '../FreeShippingProgressBar';
import { DefaultVariant } from './DefaultVariant';
import type { VariantProps } from '../types';

export function FreeShippingBarVariant(props: Readonly<VariantProps>) {
  const freeShipping = useFreeShipping(props.total, props.priceOptions.currency ?? 'USD');

  return (
    <>
      <FreeShippingProgressBar
        freeShipping={freeShipping}
        priceOptions={props.priceOptions}
      />
      <DefaultVariant {...props} />
    </>
  );
}
